<footer>
    <section class="footer-content">
        <figure class="footer-logo">
            <a href="https://www.futurocasadevalores.com/" target="_blank" title="Comunidad Futuro">
                <img src="assets/images/comunidad-futuro.svg" alt="Comunidad Futuro" loading="eager" width="205" height="53">
            </a>
        </figure>
    </section>
    <section>
        <a href="https://wa.link/yt04jk" target="_blank" class="footer-contact">
            <div class="footer-contact-icon">
                <i class="fab fa-whatsapp fa-2x"></i>
            </div>
            <div class="footer-contact-info">
                <p>Escríbenos a nuestro whatsApp</p>
                <span>+593992860166</span>
            </div>
        </a>
    </section>
</footer>
